import styled, { css } from "styled-components";
import { useDesignTokens } from "@boi/react-design-tokens";

import {
  ButtonBase as SelectButtonBase,
  ListBox as SelectListBox,
} from "../../SelectV2/SelectV2.styled";

export const Button = styled(SelectButtonBase)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { select } = tokens;

    return css`
      display: grid;
      align-items: center;
      grid-template-columns: 1fr auto;
      padding-left: ${select.button.padding.left};
      padding-right: ${select.button.padding.right};
    `;
  }}
`;

export const ButtonIconWrapper = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { select } = tokens;

    return css`
      ${Button}[data-disabled] & {
        opacity: ${select.menu.option.inner.icon.opacity.disabled};
      }

      svg {
        display: block;
        width: 32px;
        height: 22px;
      }
    `;
  }}
`;

export const ListBox = styled(SelectListBox)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { select } = tokens;

    return css`
      .react-aria-ListBoxSection:not(:empty, :last-of-type) {
        border-bottom-width: 3px;
        border-bottom-style: ${select.menu.separator.style};
        border-bottom-color: ${select.menu.separator.color};
      }
    `;
  }}
`;
